import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { TextCell } from "@tfg/ui"
import { useMemo } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

export const useGetAgecExportColumns = (): ColumnDef<
  AdminResponses.OrganizationAgecStats,
  any
>[] => {
  const columnHelper =
    createColumnHelper<AdminResponses.OrganizationAgecStats>()

  return useMemo<ColumnDef<AdminResponses.OrganizationAgecStats, any>[]>(
    () => [
      columnHelper.accessor("organizationName", {
        enableSorting: false,
        header: "Company Name",
        cell: ({ getValue }) => <TextCell value={getValue()} />,
      }),
      columnHelper.accessor("collection", {
        enableSorting: false,
        header: "Collection",
        cell: ({ getValue }) => <TextCell value={getValue()} />,
      }),
      columnHelper.accessor("totalproducts", {
        enableSorting: false,
        header: "Total products",
        cell: ({ getValue }) => <TextCell value={getValue()} />,
      }),
      columnHelper.accessor("agecCompliantProducts", {
        enableSorting: false,
        header: "Compliant Products",
        cell: ({ getValue }) => <TextCell value={getValue()} c="green" />,
      }),
      columnHelper.accessor("agecNotCompliantProducts", {
        enableSorting: false,
        header: "Not Compliant Products",
        cell: ({ getValue }) => <TextCell value={getValue()} c="red" />,
      }),
      columnHelper.accessor("compliantPercentage", {
        enableSorting: false,
        header: "Compliance percentage",
        size: 100,
        cell: ({ getValue }) => (
          <TextCell value={Number(getValue()) + "%"} ta="end" mr="1em" />
        ),
      }),
    ],
    [columnHelper]
  )
}
